import * as React from "react";
import {TemplateList} from "./TemplateList";
import './TemplateList.css';
let ReactDOM:any=require('react-dom');

export namespace SmartFormsModules {
    declare var window:any;
    declare var smartFormsPreviewUrl;
    declare var sfIsIE:()=>any;
    export class TemplateManager{
        private $templateContainer:JQuery;
        private $contactForm:JQuery;
        private $form:JQuery=null;
        private $templateDialog;
        constructor(){
            this.$templateDialog=rnJQuery('#templateManager');

            this.ShowTemplateManager();
        }

        public ShowTemplateManager() {
            rnJQuery('#smartFormsLoadingLogo').velocity({opacity:0},1000,"easeInExp");

            ReactDOM.render(<TemplateList CreateForm={x=>this.CreateForm(x)} CreatePreview={x=>this.CreatePreview(x)}/>,this.$templateDialog.find('.modal-body')[0],call=> {
                this.$templateDialog.modal('show');
            });


            /*this.$templateContainer.css('transform-origin','top left');
            rnJQuery('#sfMainContainer').css('overflow','hidden');*/

        /*    ReactDOM.render(<TemplateList/>,this.$templateContainer[0],call=>{
                this.$templateContainer.velocity({rotateZ:'-90deg'},1,"easeInExp",()=>{
                    rnJQuery('#loadingScreen').after(this.$templateContainer);
                    this.$templateContainer.velocity({rotateZ:'0deg'},600,"easeInExp", () => {


                    });
                });
            });*/
        }

        private AddForms() {
            this.GenerateFormPreview('BlankForm','Empty Form');
            this.GenerateFormPreview('BasicContactForm','Basic Contact Form');
            this.GenerateFormPreview('ServicePriceCalculation','Service Price Calculation');
            this.GenerateFormPreview('ReservationForm','Reservation Form');
            this.GenerateFormPreview('SurveyForm','Survey Form');
            this.GenerateFormPreview('Review','Review Form');


        }

        private GenerateFormPreview(id:string,title:string):void {
            let $preview:JQuery=rnJQuery(`<div class="sfTemplateItem"><div class="sfImage"><img src="${smartFormsRootPath}js/formBuilder/templateManager/templates/${id}.png"></div><hr style="margin:1px 0 0 0 ;"/><div class="sfText"><h2>${title}</h2></div></div>`);
            if(id!='BlankForm')
            {
                let $previewButton=rnJQuery('<div class="sfPreviewButton bootstrap-wrapper"><span class="fa fa-search"></span> Click here to preview</div>');
                $previewButton.click((e:any)=>{this.ExecutePreview(e,id);});
                $preview.append($previewButton);
            }
            $preview.data('form-type',id);

            $preview.click(()=>{this.FormClicked($preview)});
            $preview.velocity({scale:'0'},0,"easeInExp",()=>{
              //  this.$formList.append($preview);
                $preview.velocity({scale:'1'},300,"easeInExp",()=>{});
            });


            /*$preview.addClass('sfHidden');
            $preview.removeClass('sfHidden');*/
        }

        private FormClicked($preview:JQuery) {
            var type=$preview.data('form-type');
            if(type=='BlankForm')
            {
                SmartFormsAddNewVar.LoadForm();
                rnJQuery('#smartFormsLoadingLogo').remove();
                window.SmartFormsAddNewTutorial.Initialize(SmartFormsAddNewVar,rnJQuery('.sfTemplateContainer'));
                //this.CloseTemplateManager();
                return;
            }

            rnJQuery.getJSON(smartFormsRootPath+'js/formBuilder/templateManager/templates/'+type+'.json',(e)=>{
                window.smartFormId=0;
                window.smartFormsOptions=rnJQuery.parseJSON(e.form_options);
                window.smartFormsElementOptions=rnJQuery.parseJSON(e.element_options);
                window.smartFormClientOptions=rnJQuery.parseJSON(e.client_form_options);
                SmartFormsAddNewVar.LoadForm();
                rnJQuery('#smartFormsLoadingLogo').remove();
                window.SmartFormsAddNewTutorial.Initialize(SmartFormsAddNewVar,rnJQuery('.sfTemplateContainer'));
                //this.CloseTemplateManager();
            })
        }

        private CloseTemplateManager() {
            rnJQuery('#rootContentDiv').removeClass('OpHidden');
            rnJQuery('#loadingScreen').remove();
            this.$templateContainer.velocity({opacity:0},"easeInExp",()=>{this.$templateContainer.remove();});
        }

        private ExecutePreview(e:JQueryMouseEventObject,type) {
            e.preventDefault();
            e.stopImmediatePropagation();
            window.preview=null;
            var preview=window.open(smartFormsPreviewUrl);

            rnJQuery.getJSON(smartFormsRootPath+'js/formBuilder/templateManager/templates/'+type+'.json',(e)=>{
                window.smartFormId=0;
                window.smartFormsOptions=rnJQuery.parseJSON(e.form_options);
                window.smartFormsElementOptions=rnJQuery.parseJSON(e.element_options);
                window.smartFormClientOptions=rnJQuery.parseJSON(e.client_form_options);



                var self=this;
                if(window.sfIsIE())
                {
                    var ieIsLoaded = function ()
                    {
                        var body = preview.document.getElementsByTagName('body');
                        if (body[0] == null)
                        {
                            //page not yet ready
                            setTimeout(ieIsLoaded, 10);
                        } else
                        {
                            preview.onload = function ()
                            {
                                window.preview=preview;
                                self.OpenPreview(e.form_options,e.element_options,e.client_form_options);
                            }
                        }
                    };
                    ieIsLoaded();
                    return;
                }

                preview[preview.addEventListener ? 'addEventListener' : 'attachEvent'](
                    (preview.attachEvent ? 'on' : '') + 'load',function ()
                    {
                        window.preview=preview;
                        self.OpenPreview(e.form_options,e.element_options,e.client_form_options);
                    }, false);

            });
        }

        OpenPreview(formOptions:any,elementOptions:any,clientFormOptions:any) {
            window.preview.LoadPreview({ 'form_id':0,  'elements':rnJQuery.parseJSON(elementOptions),'client_form_options':rnJQuery.parseJSON(clientFormOptions),'container':'formContainersfpreviewcontainer'},false);
        }

        private ShowContactForm() {


        }


        private CreateForm(x: any) {
            if(x==null)
            {
                SmartFormsAddNewVar.LoadForm();
                rnJQuery('#smartFormsLoadingLogo').remove();
                window.SmartFormsAddNewTutorial.Initialize(SmartFormsAddNewVar,rnJQuery('.sfTemplateContainer'));
            }else{



                window.smartFormId=0;
                window.smartFormsOptions=rnJQuery.parseJSON(x.form_options);
                window.smartFormsElementOptions=rnJQuery.parseJSON(x.element_options);
                window.smartFormClientOptions=rnJQuery.parseJSON(x.client_form_options);
                SmartFormsAddNewVar.LoadForm();
                rnJQuery('#smartFormsLoadingLogo').remove();
                window.SmartFormsAddNewTutorial.Initialize(SmartFormsAddNewVar,rnJQuery('.sfTemplateContainer'));
            }

            this.$templateDialog.modal('hide');
        }

        private CreatePreview(e: any) {
            window.preview=null;
            var preview=window.open(smartFormsPreviewUrl);

            window.smartFormId=0;
            window.smartFormsOptions=rnJQuery.parseJSON(e.form_options);
            window.smartFormsElementOptions=rnJQuery.parseJSON(e.element_options);
            window.smartFormClientOptions=rnJQuery.parseJSON(e.client_form_options);



            var self=this;
            if(window.sfIsIE())
            {
                var ieIsLoaded = function ()
                {
                    var body = preview.document.getElementsByTagName('body');
                    if (body[0] == null)
                    {
                        //page not yet ready
                        setTimeout(ieIsLoaded, 10);
                    } else
                    {
                        preview.onload = function ()
                        {
                            window.preview=preview;
                            self.OpenPreview(e.form_options,e.element_options,e.client_form_options);
                        }
                    }
                };
                ieIsLoaded();
                return;
            }

            preview[preview.addEventListener ? 'addEventListener' : 'attachEvent'](
                (preview.attachEvent ? 'on' : '') + 'load',function ()
                {
                    window.preview=preview;
                    self.OpenPreview(e.form_options,e.element_options,e.client_form_options);
                }, false);
        }
    }
}

declare let smartforms_react_addnew:any;